/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 * @dependencies jQuery
 */

import Headroom from 'headroom.js';
import $ from 'jquery';

// Header Elements
const headerEl = document.querySelector('.js-fixed-header');
const topbarEl = document.querySelector('.js-topbar');
const anchorsEl = document.querySelector('.js-fixed-anchors');
const sizeChangeEvents = ['resize', 'orientationchange'];

// Header + topbar
if (headerEl) {
  let headerHeight = headerEl ? headerEl.offsetHeight : 0;
  let topbarHeight = topbarEl ? topbarEl.offsetHeight : 0;

  const calcHeaderHeight = () => {
    headerHeight = headerEl.offsetHeight;
    document.documentElement.style.setProperty('--header-height', ` ${headerHeight}px`);

    topbarHeight = topbarEl ? topbarEl.offsetHeight : 0;
    document.documentElement.style.setProperty('--topbar-height', ` ${topbarHeight}px`);

    if (fixedHeader) {
      fixedHeader.offset.up = topbarHeight;
      fixedHeader.offset.down = topbarHeight;
    }
  };

  window.fixedHeader = {};

  // Headroom Options
  let fixedHeader = new Headroom(headerEl, {
    offset: topbarHeight,
    tolerance: {
      up: 12,
      down: 12,
    },
    classes: {
      // when element is initialised
      initial: 'initialized',
      // when scrolling up
      pinned: 'is-pinned',
      // when scrolling down
      unpinned: 'is-unpinned',
      // when above offset
      top: 'is-top',
      // when below offset
      notTop: 'is-not-top',
      // when at bottom of scoll area
      bottom: 'is-bottom',
      // when not at bottom of scroll area
      notBottom: 'is-not-bottom',
    },
    // Custom transitions
    onUnpin: function () {
      if (anchorsEl) {
        document.documentElement.classList.add('header-unpinned');
      }
    },
    onPin: function () {
      if (anchorsEl) {
        document.documentElement.classList.remove('header-unpinned');
      }
    },
  });

  window.addEventListener('load', function () {
    calcHeaderHeight();
    fixedHeader.init();
    window.fixedHeader = fixedHeader;

    sizeChangeEvents.forEach((event) => {
      window.addEventListener(event, debounce(calcHeaderHeight));
    });
  });

  // Prevent header to show on close reveal
  const reveals = document.getElementsByClassName('reveal');
  for (let index = 0; index < reveals.length; index++) {
    const reveal = reveals[index];

    $(reveal).on('closed.zf.reveal', function () {
      headerEl.style.transition = 'none';
      setTimeout(() => {
        headerEl.style.transition = '';
      }, 100);
    });
  }
}

// Anchors
if (anchorsEl) {
  let anchorsOffset = anchorsEl.offsetTop + anchorsEl.offsetHeight;

  // Headroom options
  const calcAnchorsTop = () => {
    anchorsOffset = anchorsEl.offsetTop + anchorsEl.offsetHeight;
    if (fixedAnchors) {
      fixedAnchors.offset.up = anchorsOffset;
      fixedAnchors.offset.down = anchorsOffset;
    }
  };

  window.fixedAnchors = {};

  let fixedAnchors = new Headroom(anchorsEl, {
    offset: anchorsOffset,
    tolerance: {
      up: 0,
      down: 12,
    },
    classes: {
      // when element is initialised
      initial: 'initialized',
      // when scrolling up
      pinned: 'is-pinned',
      // when scrolling down
      unpinned: 'is-unpinned',
      // when above offset
      top: 'is-top',
      // when below offset
      notTop: 'is-not-top',
      // when at bottom of scoll area
      bottom: 'is-bottom',
      // when not at bottom of scroll area
      notBottom: 'is-not-bottom',
    },
    // Custom transitions
    onTop: function () {
      document.querySelector('.header').classList.remove('sticky-anchors');
    },
    onNotTop: function () {
      document.querySelector('.header').classList.add('sticky-anchors');
    },
  });

  window.addEventListener('load', function () {
    calcAnchorsTop();
    fixedAnchors.init();

    sizeChangeEvents.forEach((event) => {
      window.addEventListener(event, debounce(calcAnchorsTop));
    });
  });
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
